import RoleListing from './container/index';

export default RoleListing;
